<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="credit-card"
    data-name="Credit card.10"
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
  >
    <g id="Group_1060" data-name="Group 1060" transform="translate(3.5 5.833)">
      <path
        id="Path_8469"
        data-name="Path 8469"
        d="M3,9.667H24M10.665,14.333h-3m12.833,7H6.5a3.5,3.5,0,0,1-3.5-3.5V8.5A3.5,3.5,0,0,1,6.5,5h14A3.5,3.5,0,0,1,24,8.5v9.333A3.5,3.5,0,0,1,20.5,21.333Z"
        transform="translate(-3 -5)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
    <path id="Path_8470" data-name="Path 8470" d="M0,0H28V28H0Z" fill="none" />
  </svg>
</template>
